import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface SurveyToggleState {
  isTargeted: { [key: string]: boolean };
  isUsingConfidenceInterval: { [key: string]: boolean };
}

export const defaultSurveyToggleState: SurveyToggleState = {
  isTargeted: {},
  isUsingConfidenceInterval: {},
};

export const surveyTargetingToggleSlice = createSlice({
  initialState: defaultSurveyToggleState,
  name: 'surveyTargetingState',
  reducers: {
    clearSurveyTargetingState() {
      return defaultSurveyToggleState;
    },
    setSurveyTargetingToggle(state, { payload: { surveyId, isTargeted } }: PayloadAction<{ surveyId: string, isTargeted: boolean }>) {
      if (!state.isTargeted) {
        state.isTargeted = {};
      }

      state.isTargeted[surveyId] = isTargeted;
    },
    setSurveyConfidenceToggle(state, { payload: { surveyId, isUsingConfidenceInterval } }: PayloadAction<{ surveyId: string, isUsingConfidenceInterval: boolean }>) {
      if (!state.isUsingConfidenceInterval) {
        state.isUsingConfidenceInterval = {};
      }

      state.isUsingConfidenceInterval[surveyId] = isUsingConfidenceInterval;
    },
  },
});

export const {
  clearSurveyTargetingState,
  setSurveyTargetingToggle,
  setSurveyConfidenceToggle,
} = surveyTargetingToggleSlice.actions;

export default surveyTargetingToggleSlice.reducer;
